import { render } from "./ActionPage.vue?vue&type=template&id=4cc22a34&scoped=true"
import script from "./ActionPage.vue?vue&type=script&lang=js"
export * from "./ActionPage.vue?vue&type=script&lang=js"

import "./ActionPage.vue?vue&type=style&index=0&id=4cc22a34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc22a34"]])

export default __exports__